module.exports = __webpack_public_path__ + "static/screenshot3-32d9983891f4cee03df53e7121bdffb6.png";